import { createRoot } from 'react-dom/client'
import { NecklaceBuilder } from './components/NecklaceBuilder'
import { AppProvider } from './context/AppContext'

const container = document.getElementById('feature-necklace-builder')!
const root = createRoot(container)
root.render(
  <AppProvider>
    <NecklaceBuilder />
  </AppProvider>
)
